export default {
  type: "Feature",
  properties: {
    name: "Замын-Үүд",
    location: [43.2139, 112.0042],
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[43.72138578857618, 111.90750215529788]]],
  },
};
